import {
	FormControl,
	Grid,
	InputLabel,
	MenuItem,
	Select,
	type Theme,
	createStyles,
	makeStyles,
} from "@material-ui/core";
import { useEffect, useState } from "react";
import { useFormsContext } from "../../../../context/FormsContext";
import { ErrorModal, getUsers } from "@dexteel/mesf-core";

const ITEM_HEIGHT = 48;
const ITEM_PADDING_TOP = 8;
const MenuProps = {
	PaperProps: {
		style: {
			maxHeight: ITEM_HEIGHT * 4.5 + ITEM_PADDING_TOP,
			width: 250,
		},
	},
};

const useStyles = makeStyles((theme: Theme) =>
	createStyles({
		root: {
			"& .MuiSelect-root": {
				backgroundColor: "#FFF",
			},
		},
		formControl: {
			width: "99%",
			marginTop: 8,
		},
		chips: {
			display: "flex",
			flexWrap: "wrap",
		},
		chip: {
			margin: 2,
		},
		noLabel: {
			marginTop: theme.spacing(3),
		},
	}),
);

type Props = {
	value: number;
	onChange: Function;
	disabled?: boolean;
};

export const UsersPicker = ({ value, onChange, disabled }: Props) => {
	const classes = useStyles();
	const [isLoading, setIsLoading] = useState(false);
	const [error, setError] = useState("");
	const {
		state: { users },
		actions: { setUsers },
	} = useFormsContext();

	useEffect(() => {
		const searchUsers = async () => {
			setIsLoading(true);
			try {
				const listUsers = await getUsers();
				listUsers.sort((a: any, b: any) =>
					a.UserName.localeCompare(b.UserName),
				);
				setUsers(listUsers);
				setIsLoading(false);
			} catch (error) {
				setError(
					error instanceof Error ? error.message : "Error loading users",
				);
				setIsLoading(false);
			}
		};

		searchUsers();
	}, []);

	return (
		<div className={classes.root}>
			{users.length ? (
				<FormControl
					variant="outlined"
					margin="dense"
					className={classes.formControl}
				>
					<InputLabel id="user-select-label">User</InputLabel>
					<Select
						labelId="user-select-label"
						id="user-select"
						disabled={disabled ? disabled : false}
						autoWidth={true}
						value={value}
						onChange={onChange as any}
						label="User"
						MenuProps={MenuProps}
					>
						{users.map((user) => (
							<MenuItem
								key={`user-${user.UserId}`}
								value={user.UserId as number}
							>
								<Grid container alignItems="center">
									<div
										style={{
											color: "#FFF",
											fontWeight: 600,
											margin: "auto 0",
											lineHeight: 0,
										}}
									>
										<div style={{ marginLeft: "-40px" }}>
											{user.UserName.charAt(0) || ""}
										</div>
									</div>
									<div>{user.UserName}</div>
								</Grid>
							</MenuItem>
						))}
					</Select>
				</FormControl>
			) : (
				<></>
			)}
			<ErrorModal error={error} onHide={() => setError("")} />
		</div>
	);
};
